module.exports = __webpack_public_path__ + "img/close.e3fb016a.svg";